import { registerPlugin, Capacitor } from '@capacitor/core';

// Plugin nativo BuildInfo (iOS: BuildInfoPlugin.swift, Android: BuildInfoPlugin.java).
const BuildInfo = registerPlugin('BuildInfo');

/**
 * true SOLO quando l'app gira su una build nativa Debug installata dall'IDE
 * (Android Studio / Xcode, via cavo o wireless).
 * false sulle build Release distribuite (TestFlight / Google Play) e sul web.
 *
 * Serve a mostrare il badge "LOCALE" e capire a colpo d'occhio se sullo
 * smartphone si sta guardando la build appena compilata in locale e non
 * quella scaricata dalle piattaforme di test.
 */
export async function isLocalDebugBuild() {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    const { isDebug } = await BuildInfo.isDebug();
    return !!isDebug;
  } catch {
    return false;
  }
}
